import { useAuth } from "@/contexts/AuthContext";
import { isTenantManagerPlus } from "@/shared/lib/rbac";

/**
 * 发布 / 回滚 / 域名绑定解绑这些写口只给 TENANT_MANAGER+(附录 A.59,api `@PreAuthorize("hasRole('TENANT_MANAGER')")`);
 * STAFF 能编辑但看不到这些按钮。角色用 AuthContext 的 `effectiveRole`(代客态 = TENANT_ADMIN,否则真实身份)。
 * ★ 只是藏按钮,真正的闸在 api。
 */
export function useCanManageSite(): boolean {
  const { effectiveRole } = useAuth();
  return isTenantManagerPlus(effectiveRole);
}
